<template>
  <Modal
    class="cc-modal"
    width="1200"
    footer-hide
    v-model="visibility"
    title="我的域名列表"
  >
    <div class="content" v-if="data">
      <div class="con-row">
        <div class="item">域名状态：</div>
        <div
          :class="['item', { active: item.value === searchObj.domainStatus }]"
          v-for="item in domainStatusList"
          :key="item.value"
          @click="onCheckDomainStatus(item.value)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">交易状态：</div>
          <Select
            v-model="searchObj.bargainStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in bargainStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="item">
          <div style="margin-right: 10px">实名认证：</div>
          <Select
            v-model="searchObj.approvedStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in approvedStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="item">
          <div style="margin-right: 10px">域名品类：</div>
          <Cascader
            :data="domainQueryData.domainTypeList"
            v-model="domainTypeStr"
            style="width: 200px"
            transfer
            clearable
          ></Cascader>
        </div>
        <div class="item">
          <div style="margin-right: 10px">自动续费：</div>
          <Select
            v-model="searchObj.isAutoRenew"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in isAutoRenewList"
              :value="item.value"
              :key="item.value"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-right: 0">
          <div style="margin-right: 10px">域名后缀：</div>
          <Select
            v-model="searchObj.domainSuffix"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in domainQueryData.domainSuffix"
              :value="item.domainSufName"
              :key="item.domainSufName"
              >{{ item.domainSufName }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-right: 100px">
          <div style="margin-right: 10px">模板：</div>
          <Button type="primary" @click="showCheckedTemplate">{{
            !templateInfo.templateId ? "选择模板" : templateInfo.templateName
          }}</Button>
        </div>
        <div class="item" style="margin-right: 100px">
          <div style="margin-right: 10px">注册 / 转入时间：</div>
          <DatePicker
            :value="registeredAtArr"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="注册 / 转入时间"
            style="width: 240px"
            @on-change="onRegisteredChange"
          ></DatePicker>
        </div>
        <div class="item" style="margin-right: 60px">
          <div style="margin-right: 10px">过期时间：</div>
          <DatePicker
            :value="expiredStartTimeArr"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="注册 / 转入时间"
            style="width: 240px"
            @on-change="onExpiredTimeChange"
          ></DatePicker>
        </div>
        <div class="item" style="margin-right: 60px">
          <div style="margin-right: 10px">域名长度：</div>
          <Input
            v-model="searchObj.startExtent"
            placeholder="开始长度"
            style="width: 100px"
            clearable
          />
          <span>-</span>
          <Input
            v-model="searchObj.endExtent"
            placeholder="结束长度"
            style="width: 100px"
            clearable
          />
        </div>
        <div class="item" style="margin-right: 60px">
          <div style="margin-right: 10px">域名包含：</div>
          <Input
            v-model="searchObj.name"
            placeholder="开始长度"
            style="width: 300px"
            clearable
          />
          <CheckboxGroup v-model="searchObj.rule" style="margin-left: 20px">
            <Checkbox :label="0"> 开头</Checkbox>
            <Checkbox :label="1"> 结尾</Checkbox>
          </CheckboxGroup>
        </div>
        <div class="item">
          <Button type="primary" style="margin-right: 20px" @click="onSearch">
            搜索</Button
          >
          <Button @click="onSearchCancel"> 重置</Button>
        </div>
      </div>
      <!-- @on-row-click="tableSelect" -->
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
        @on-select="select"
        @on-select-cancel="selectCancel"
        @on-select-all="($event) => allSelect($event, true)"
        @on-select-all-cancel="($event) => allSelect($event, false)"
      >
        <template slot="isExternal" slot-scope="{ row }">
          {{ row.isExternal === 0 ? "智绘网络" : "外部" }}
        </template>
      </Table>
    </div>
    <div class="foot">
      <div class="page-tool">
        <Page
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          show-total
          @on-change="onPageChange"
        />
      </div>
      <div>
        <Button @click="onConfirm" type="primary" style="margin-right: 20px"
          >确定</Button
        >
        <Button @click="onCancel">取消</Button>
      </div>
    </div>
    <!-- 选择模板 -->
    <templateListModal
      :show.sync="templateListModalVisibility"
      @onChecked="checkedTemplate"
    ></templateListModal>
  </Modal>
</template>
<script>
import { domainList } from "api/domain.js";
import { mapActions, mapState } from "vuex";
import templateListModal from "components/template/templateListModal.vue";
export default {
  name: "domainListModal",
  components: {
    templateListModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // 选中的域名
    checkedDomain: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableLoading: false,
      columns: [
        {
          type: "selection",
          title: "全选",
          width: 60,
          align: "center",
        },
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          key: "name",
          title: "域名",
          align: "center",
        },
        {
          slot: "isExternal",
          title: "注册商",
          align: "center",
        },
      ],
      searchObj: {
        domainStatus: -1,
        bargainStatus: -1,
        approvedStatus: -1,
        // 域名品类(一级)
        domainType: "",
        // 域名构成(二级)
        domainConstruction: "",
        // 自动续费
        isAutoRenew: "",
        // 域名后缀
        domainSuffix: "",
        // 注册/转入结束时间
        endedTime: "",
        // 注册/转入开始时间
        registeredAt: "",
        // 过期时间
        expiredStartTime: "",
        expiredEndTime: "",
        // 域名长度
        startExtent: "",
        endExtent: "",
        name: "",
        rule: [],
        page: 1,
        limit: 10,
        total: 0,
      },
      // 域名状态
      domainStatusList: [
        {
          name: "全部域名",
          value: -1,
        },
        {
          name: "30天内到期",
          value: 0,
        },
        {
          name: "已过期",
          value: 1,
        },
        {
          name: "赎回期",
          value: 2,
        },
      ],
      // 交易状态
      bargainStatusList: [
        {
          name: "正在出售",
          value: 0,
        },
        {
          name: "正在push",
          value: 1,
        },
        {
          name: "正在交易",
          value: 2,
        },
        {
          name: "正在转出",
          value: 3,
        },
      ],
      // 实名认证
      approvedStatusList: [
        {
          name: "未认证",
          value: 0,
        },
        {
          name: "认证中(审核中)",
          value: 1,
        },
        {
          name: "认证成功(审核通过)",
          value: 2,
        },
        {
          name: "认证失败(审核未通过)",
          value: 3,
        },
      ],
      domainTypeStr: [],
      isAutoRenewList: [
        {
          name: "否",
          value: 0,
        },
        {
          name: "是",
          value: 1,
        },
      ],
      // 转入时间
      registeredAtArr: [],
      expiredStartTimeArr: [],
      data: [],
      value: [], // 选中的数据
      templateListModalVisibility: false,
      templateInfo: {},
    };
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.req_getList();
        }
      },
    },
    checkedDomain: {
      immediate: true,
      handler(val) {
        this.value = val;
      },
    },
  },
  computed: {
    ...mapState(["domainQueryData"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  mounted() {
    if (
      this.domainQueryData.domainTypeList.length === 0 ||
      this.domainQueryData.domainSufNameList.length === 0
    ) {
      this.ACT_DOMAIN_QUERY();
    }
  },
  methods: {
    ...mapActions(["ACT_DOMAIN_QUERY"]),
    // 获取数据
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
        };
        this.searchObj.domainStatus !== -1 &&
          (params.expiredStatus = this.searchObj.domainStatus);
        this.searchObj.bargainStatus !== -1 &&
          (params.bargainStatus = this.searchObj.bargainStatus);
        this.searchObj.approvedStatus !== -1 &&
          (params.approvedStatus = this.searchObj.approvedStatus);
        this.searchObj.domainType &&
          (params.domainType = this.searchObj.domainType);
        this.searchObj.domainConstruction &&
          (params.domainConstruction = this.searchObj.domainConstruction);
        this.searchObj.isAutoRenew &&
          (params.isAutoRenew = this.searchObj.isAutoRenew);
        this.searchObj.domainSuffix &&
          (params.domainSuffix = this.searchObj.domainSuffix);
        this.searchObj.registeredAt &&
          (params.registeredAt = this.searchObj.registeredAt);
        this.searchObj.endedTime &&
          (params.endedTime = this.searchObj.endedTime);
        this.searchObj.expiredStartTime &&
          (params.expiredStartTime = this.searchObj.expiredStartTime);
        this.searchObj.expiredEndTime &&
          (params.expiredEndTime = this.searchObj.expiredEndTime);
        this.searchObj.startExtent &&
          (params.startExtent = this.searchObj.startExtent);
        this.searchObj.endExtent &&
          (params.endExtent = this.searchObj.endExtent);
        this.searchObj.name && (params.name = this.searchObj.name);
        this.searchObj.rule.length > 0 &&
          (params.rule = this.searchObj.rule[0]);
        this.templateInfo.templateId &&
          (params.TId = this.templateInfo.templateId);
        this.tableLoading = true;
        const { code, data } = await domainList(params);
        this.tableLoading = false;
        if (code === 200) {
          let array = data.list.map((o) => {
            let isCheckEd = false;
            if (this.checkedDomain.length > 0) {
              isCheckEd = this.checkedDomain.some((v) => {
                return v === o.name;
              });
            }
            return { ...o, _checked: isCheckEd };
          });
          this.data = array;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 取消
    onCancel() {
      this.visibility = false;
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.templateInfo = {};
      this.onPageChange(1);
    },
    // 分页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 域名转台改变
    onCheckDomainStatus(val) {
      this.searchObj.domainStatus = val;
      this.onPageChange(1);
    },
    // 日期改变
    onRegisteredChange(event) {
      this.searchObj.registeredAt = event[0];
      this.searchObj.endedTime = event[1];
    },
    // 日期改变
    onExpiredTimeChange(event) {
      this.searchObj.expiredStartTime = event[0];
      this.searchObj.expiredEndTime = event[1];
    },
    // 确定
    onConfirm() {
      this.$emit("onChecked", this.value);
      this.onCancel();
    },
    // 打开选择模板
    showCheckedTemplate() {
      this.templateListModalVisibility = true;
    },
    // 选中模板回调
    checkedTemplate(val) {
      this.templateInfo = val;
      this.templateListModalVisibility = false;
    },
    // 全选
    allSelect(event, val) {
      this.data.forEach((o, index) => {
        !o._disabled && (o._checked = val);
        this.$set(this.data, index, o);
      });
      let selfData = this.data.map((o) => {
        return o.name;
      });
      // 去重
      if (val) {
        let tempArray = [...this.value, ...selfData];
        this.value = Array.from(new Set(tempArray));
      } else {
        this.value = selfData.filter((o) => !this.value.includes(o));
      }
    },
    // 选中
    select() {
      let row = arguments[1];
      if (!row._disabled) {
        let index = this.data.findIndex((o) => o.name === row.name);
        row._checked = true;
        // 对比数据中有没有选中的数据
        !this.value.some((o) => o === row.name) && this.value.push(row.name);
        this.$set(this.data, index, row);
      }
    },
    // 取消选中
    selectCancel() {
      let row = arguments[1];
      let index = this.data.findIndex((o) => o.name === row.name);
      row._checked = false;
      // 查找下标
      let cindex = this.value.findIndex((o) => o === row.name);
      cindex !== -1 && this.value.splice(cindex, 1);
      this.$set(this.data, index, row);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .cc-modal {
  .ivu-table-tip td {
    border-bottom: none;
  }
}
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
.con-row {
  display: flex;
  height: 40px;
  line-height: 40px;
  .item {
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    cursor: pointer;
    margin-right: 40px;
  }
  .item.active {
    color: #3992e9;
  }
}
.cond-row {
  display: flex;
  flex-wrap: wrap;
  line-height: 60px;
  .item {
    display: flex;
    align-items: center;
    margin: 0 20px;
  }
}
.page-tool {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
